export default __webpack_public_path__ + "static/media/SL_imageX2.2c3cbc8a.png";